/* Справочники предметной области. ТЗ разделы 4, 5.2, 5.10.
   Значения строковые и совпадают с прототипом один-в-один — по ним матчатся
   операции, этапы воронок и категории, поэтому менять их нельзя без миграции. */

/* Перевод — это не доход и не расход: деньги остаются в группе, просто меняют
   счёт. Поэтому в выручку, расходы, ОДДС и P&L он не входит, а балансы обоих
   счетов двигает: с одного списывается, на другой приходит. */
export const OP_TYPES = ["Поступление", "Расход", "Перевод"];
export const TRANSFER = "Перевод";
export const OP_ACTS = ["Операционная", "Инвестиционная", "Финансовая"];

export const EXPENSE_CATS = [
  "Зарплата / ФОТ",
  "Подрядчики / Аутсорс",
  "Маркетинг и реклама",
  "Хостинг / Облако",
  "Офис и операционка",
  "Юридические расходы",
  "Оборудование",
  "Прочие расходы",
];
export const INCOME_CATS = ["Выручка от клиентов", "Инвестиции"];

/* «Оборудование» — капзатрата, в операционные расходы P&L не входит (ТЗ 7.6) */
export const CAPEX_CATS = ["Оборудование"];
export const OPEX_CATS = EXPENSE_CATS.filter((c) => !CAPEX_CATS.includes(c));

export const REVENUE_CAT = "Выручка от клиентов";
export const INVEST_CAT = "Инвестиции";

/* ── Воронки продаж ────────────────────────────────────────
   Ниже — значения по умолчанию для новых бизнесов. Фактический набор этапов
   каждого бизнеса хранится в БД (businesses.sales_stages / acc_stages),
   поэтому воронку можно завести любую, а не только эти две. */

/** Этапы воронки продаж по умолчанию (порядок важен: индекс = вес этапа) */
export const DEFAULT_SALES_STAGES = [
  "База", "Коснулись", "Вышли в 2-ст диалог", "Провели звонок", "Дали КП",
  "Согл. договор", "Подписались + счёт", "Получили оплату",
];

/** Стадии аккаунтинга по умолчанию */
export const DEFAULT_ACC_STAGES = ["в работе", "на подписке", "пауза/закрыт"];

/** Этапы воронки партнёров — подставляются, когда её включают в настройках бизнеса */
export const DEFAULT_PARTNER_STAGES = ["Знакомство", "Обсуждаем условия", "Договорились", "Приводит клиентов"];

/** Этапы воронки разработки по умолчанию */
export const DEFAULT_DEV_STAGES = ["Бэклог", "В работе", "На проверке", "Готово"];

/* ── Воронки продаж (порядок важен: индекс = вес этапа) ── */
export const SALES_FUNNELS = {
  dialogic: [
    "База", "Коснулись", "Вышли в 2-ст диалог", "Провели звонок", "Дали КП",
    "Сделали перс. демо", "Согл. договор", "Подписались + счёт", "Получили оплату",
  ],
  mera: [
    "База", "Коснулись", "Вышли в 2-ст диалог", "Провели звонок", "Дали КП",
    "Согл. договор", "Подписались + счёт", "Получили оплату",
  ],
};
export const BASE_STAGE = "База";
export const salesFunnel = (funnel) => SALES_FUNNELS[funnel] || SALES_FUNNELS.dialogic;

/* ── Воронка аккаунтинга ── */
export const ACC_STAGES = {
  dialogic: ["в работе", "на подписке", "пауза/закрыт"],
  mera: ["аналитика", "дизайн", "разработка", "правки", "приёмка/сдача", "пауза/закрыт"],
};
export const ACC_CLOSED = "пауза/закрыт";
export const ACC_SUBSCRIBED = "на подписке";

/* Названия стадий бизнес заводит сам, и написаны они у всех по-разному:
   «На подписке» против «на подписке», «Закрыт» и «Пауза» вместо «пауза/закрыт».
   Точное сравнение с константой на таких воронках молча не срабатывало — MRR
   обнулялся, а закрытые проекты считались открытыми. Поэтому смысл стадии
   узнаём по её названию, а не по совпадению строк. */
const stageWord = (stage) => String(stage || "").trim().toLowerCase();
/** Подписка: с этой стадии клиент платит ежемесячно */
export const isSubscribedStage = (stage) => stageWord(stage).includes("подписк");
/** Работа кончилась: закрытые и поставленные на паузу проекты в счёт не идут */
export const isClosedStage = (stage) => {
  const s = stageWord(stage);
  return s.includes("закрыт") || s.includes("пауза");
};

/* ── Воронка разработки ──
   Доска фич и багов бизнеса: карточки живут в DevTask и не привязаны
   ни к сделке, ни к проекту — только к бизнесу и его этапам. */
export const DEV_KINDS = ["Фича", "Баг", "Задача"];
export const DEV_KIND_META = {
  "Фича": { color: "#4a5ec6" },
  "Баг": { color: "#d85046" },
  "Задача": { color: "#9a98a6" },
};

/* ── Потоки внутри CRM ──
   Устаревший справочник первых двух бизнесов; живой набор потоков — streamsOf.
   Партнёры вернулись необязательной воронкой: заводятся в настройках бизнеса. */
export const CRM_STREAMS = {
  dialogic: [
    { id: "clients", l: "Клиенты" },
    { id: "accounting", l: "Аккаунтинг" },
    { id: "tasks", l: "Задачи" },
  ],
  mera: [
    { id: "clients", l: "Клиенты" },
    { id: "accounting", l: "Аккаунтинг" },
    { id: "tasks", l: "Задачи" },
  ],
};
export const CRM_BIZ_LABEL = { dialogic: "Dialogic AI", mera: "МЕРА" };

/* ── Конфиг бизнеса ────────────────────────────────────────
   Единая точка чтения настроек. Источник правды — то, что задано у бизнеса
   в БД: воронка без этапов считается незаведённой и в CRM не показывается.
   Значения по умолчанию подставляет API при создании бизнеса, а не эти чтения. */

const nonEmpty = (v) => (Array.isArray(v) && v.length ? v : null);

/** Этапы воронки продаж бизнеса; пусто — воронки нет */
export const salesStagesOf = (business) => nonEmpty(business?.salesStages) || [];

/** Этапы воронки партнёров бизнеса; пусто — воронки нет */
export const partnerStagesOf = (business) => nonEmpty(business?.partnerStages) || [];

/* ── Воронки сделок ──
   Сделки живут в двух воронках бизнеса: продажи (clients) и партнёры (partners).
   Карточка одна и та же, а этапы и цвета этапов у каждой воронки свои. */
export const DEAL_STREAMS = ["clients", "partners"];

/** Воронка сделки: всё незнакомое (и старые записи без поля) — продажи */
export const dealStreamOf = (deal) => (deal?.stream === "partners" ? "partners" : "clients");

/** Этапы воронки, в которой живёт сделка */
export const dealStagesOf = (business, stream) =>
  stream === "partners" ? partnerStagesOf(business) : salesStagesOf(business);

/** Ключ цветов этапов в businesses.stage_colors */
export const dealColorScope = (stream) => (stream === "partners" ? "partner" : "sales");

/** Стадии аккаунтинга бизнеса; пусто — воронки нет */
export const accStagesOf = (business) => nonEmpty(business?.accStages) || [];

/** Этапы воронки разработки бизнеса; пусто — воронки нет */
export const devStagesOf = (business) => nonEmpty(business?.devStages) || [];

/* ── Цвета этапов ──
   По умолчанию колонки красятся градиентом по позиции в воронке. Если цвет этапа
   выбран руками в настройках бизнеса, он перебивает градиент. Ключи — воронка
   ('sales' | 'partner' | 'acc' | 'dev'), чтобы одинаковые названия в разных воронках не мешали. */

/** Палитра выбора: по кругу оттенков, последний — нейтральный серый */
export const STAGE_PALETTE = [
  "#d85046", "#e07a3f", "#d8a441", "#a3b23c", "#4cb478", "#3fb0a2",
  "#3f9fd8", "#4a5ec6", "#6b56c8", "#9a55c0", "#c85797", "#8e8e93",
];

/** Карта «этап → цвет» для одной воронки бизнеса */
export const stageColorsOf = (business, scope) => business?.stageColors?.[scope] || {};

/* ── Цвет бизнеса (tone) ──
   Раньше в поле лежало название («blue»), теперь — сам цвет из палитры.
   Старые записи переводим на лету, чтобы не ходить в базу за миграцией. */
const LEGACY_TONES = {
  blue: "#4a5ec6", green: "#4cb478", gold: "#d8a441", red: "#d85046",
};

/** Цвет бизнеса или участника: hex как есть, старое название — по карте */
export const toneColor = (tone, fallback = null) => {
  if (!tone) return fallback;
  if (tone.startsWith("#")) return tone;
  return LEGACY_TONES[tone] || fallback;
};

/** Цвет этапа: выбранный руками либо запасной (обычно градиент по позиции) */
export const stageTint = (business, scope, stage, fallback) =>
  stageColorsOf(business, scope)[stage] || fallback;

/** Счета бизнеса; пусто — деньги ему пока некуда класть.
    Первый в списке считается основным: на него ложатся оплаты без явного выбора */
export const accountsOf = (business) => nonEmpty(business?.accounts) || [];

/** Потоки CRM: показываем только те воронки, у которых заданы этапы */
export function streamsOf(business) {
  const out = [];
  if (salesStagesOf(business).length) out.push({ id: "clients", l: "Клиенты" });
  if (partnerStagesOf(business).length) out.push({ id: "partners", l: "Партнёры" });
  if (accStagesOf(business).length) out.push({ id: "accounting", l: "Аккаунтинг" });
  if (devStagesOf(business).length) out.push({ id: "dev", l: "Разработка" });
  out.push({ id: "tasks", l: "Задачи" });
  return out;
}

/** Есть ли у бизнеса хоть одна заведённая воронка — иначе ему нечего делать в CRM */
export const hasAnyFunnel = (business) => streamsOf(business).some((s) => s.id !== "tasks");

/* ── Уведомления ───────────────────────────────────────────
   Каждый вид включается отдельно. Выключенный не приходит в бота
   и не показывается человеку в мини-аппе. */
export const NOTIFY_KINDS = [
  { id: "tasks", label: "Задачи и напоминания" },
  { id: "deals", label: "Сделки без движения" },
  { id: "dev", label: "Задачи разработки" },
  { id: "income", label: "Поступления нам" },
  { id: "expenses", label: "Наши расходы" },
  { id: "reports", label: "Отчёты" },
  { id: "morning", label: "План на день" },
];

/** Настройки уведомлений участника: не заданное считается включённым */
export const notifyOf = (user) => {
  const saved = user?.notify || {};
  return Object.fromEntries(NOTIFY_KINDS.map((k) => [k.id, saved[k.id] !== false]));
};

/** Разрешён ли этот вид уведомлений участнику */
export const notifyAllows = (user, kind) => notifyOf(user)[kind] !== false;

/* ── Тиры ── */
export const TIERS = ["A+", "A", "B", "C"];
export const TIER_RANK = { "A+": 0, A: 1, B: 2, C: 3 };
export const TIER_META = {
  "A+": { label: "A+", color: "#c9a227", bg: "rgba(201,162,39,0.14)" },
  A: { label: "A", color: "#4a5ec6", bg: "rgba(74,94,198,0.14)" },
  B: { label: "B", color: "#4cb478", bg: "rgba(76,180,120,0.14)" },
  C: { label: "C", color: "#9a98a6", bg: "rgba(154,152,166,0.14)" },
};

/* ── Статусы проектов и платежей ── */
export const PROJECT_STATUSES = ["active", "onhold", "starting", "negotiation"];
export const PAYMENT_STATUSES = ["received", "expected", "forecast"];
export const PROJECT_KINDS = ["agency", "accounting", "product"];

/* ── Цели ── */
export const CASH_GOAL = 1_250_000; // цель кэшфлоу в общак, ТЗ 7.3

/* ── Каналы записи (аудит, ТЗ 11) ── */
export const CHANNELS = ["web", "telegram"];

export const MONTHS_RU = [
  "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
  "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
];
export const MONTHS_SHORT_RU = ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"];
